<div class="popup-wrapper">
    <head class="heading">
        <div class="heading-header">
            <span>
                Great Choice!
            </span>
        </div>
        <div class="heading-info">
            <span>
                Your investments are allocated across the investment options as mentioned below.
                You could choose to change your allocation or proceed with investments.
            </span>
        </div>
    </head>
    <body class="body">
        <div class="body-headings">
            <span>
                Your Fund Allocation
            </span>
        </div>
        <app-products-invest-amount
        [productList]="this.productList"></app-products-invest-amount>
        <div *ngIf="remainingWalletBalance != 0" class="body-box-balance">
            <span class="body-balance-label">Amount Difference:</span>
            <span [ngClass]="remainingWalletBalance > 0 ? 'green': 'red'" class="body-balance-amount"><app-indian-currency-formatter
                [amount]="walletAmountToShow">
            </app-indian-currency-formatter></span>
        </div>
    </body>
    <footer class="footer">
        <button class="outline-btn" (click)="onChangeAllocation()">CHANGE ALLOCATION</button>
        <button class="normal-btn" (click)="onInvestNow()">CONFIRM INVESTMENT</button>
    </footer>
</div>